import { ARC_ENVIRONMENT } from './arc-env';
const ArcDomains = {
  dev: 'arc-dev.org',
  staging: 'arc-staging.org',
  prod: 'avbarc.com'
};
export const ARC_DOMAIN = ArcDomains[ARC_ENVIRONMENT];